/* eslint-disable */
import React, {useState} from 'react';
//css
import 'contents/assets/scss/page/teacher.scss';
//component
import Calendar from '../../../component/Inc/Calendar';
import Paging from '../../../component/Inc/Paging';
import Tab from '../../../component/Inc/Tab';
import PopRequestPoint from '../../mypage/_PopRequestPoint';
import PopPolicyPoint from '../../mypage/_PopPolicyPoint';
import PopPolicyPosition from '../../mypage/_PopPolicyPosition';
//image
function IncentiveDetail() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalPositionOpen, setModalPositionOpen] = useState(false);
  const [modalPolicyOpen, setModalPolicyOpen] = useState(false);

  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '포인트 이력', value: 0},
    {title: '직급가점 이력', value: 1}
  ];
  return (
    <main className="com_container p_mentor_manage">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_8">
            사수 관리
            <span className="bar" />
            <span className="point_txt">홍교사103ㆍ수학</span>
            <span className="state">진급대상자</span>
          </h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalPolicyOpen(true)} className="com_btn orange s btn_settings">
              포인트 정책
            </button>
            <button onClick={() => setModalPositionOpen(true)} className="com_btn orange s btn_settings">
              직급가점 정책
            </button>
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
              포인트 & 직급가점 요청
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <table className="com_board_list">
              <colgroup>
                <col width="16%" />
                <col width="16%" />
                <col width="16%" />
                <col width="16%" />
                <col width="16%" />
                <col width="16%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>입사일</th>
                  <td>2023, 05, 12</td>
                  <th>보유 포인트</th>
                  <td>456</td>
                  <th>다음 진급 필요 포인트</th>
                  <td>12</td>
                </tr>
                <tr>
                  <th>직급</th>
                  <td>
                    선임 2호봉
                    <br />
                    2022, 05, 12
                  </td>
                  <th>보유 직급 가점</th>
                  <td>21</td>
                  <th>다음 필요 직급 가점</th>
                  <td>41</td>
                </tr>
              </tbody>
            </table>
            <Calendar />
            <table className="com_board_list">
              <colgroup>
                <col width="140" />
                <col width="140" />
                <col width="140" />
                <col width="140" />
                <col width="140" />
                <col width="140" />
                <col width="140" />
              </colgroup>
              <thead>
                <tr>
                  <th>수업</th>
                  <th>인센</th>
                  <th>손실</th>
                  <th>CS</th>
                  <th>기여</th>
                  <th>직급 포인트</th>
                  <th>직급 가점</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>45</td>
                  <td>45</td>
                  <td>45</td>
                  <td>45</td>
                  <td>45</td>
                  <td>45</td>
                  <td>45</td>
                </tr>
              </tbody>
            </table>

            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="100" />
                <col width="90" />
                <col width="auto" />
                <col width="auto" />
                <col width="60" />
                <col width="60" />
                <col width="60" />
                <col width="60" />
                <col width="60" />
                <col width="80" />
                <col width="60" />
                <col width="110" />
              </colgroup>
              <thead>
                <tr>
                  <th>No</th>
                  <th>요청일</th>
                  <th>요청자</th>
                  <th>요청항목</th>
                  <th>요청 포인트</th>
                  <th>수업</th>
                  <th>인센</th>
                  <th>손실</th>
                  <th>CS</th>
                  <th>기여</th>
                  <th>직급 포인트</th>
                  <th>합산</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td>2023, 05, 23</td>
                  <td>
                    <button className="btn_link">김요청305</button>
                  </td>
                  <td>교재제작검토</td>
                  <td className="com_red_txt">-35</td>
                  <td>64</td>
                  <td>64</td>
                  <td>645</td>
                  <td>64</td>
                  <td>-</td>
                  <td>645</td>
                  <td>645</td>
                  <td>
                    <span className="com_red_txt btn_link">승인요청</span>
                  </td>
                </tr>
                {[2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>2023, 05, 23</td>
                      <td>
                        <button className="btn_link">김요청305</button>
                      </td>
                      <td>교재제작검토</td>
                      <td className="com_blue_txt">+35</td>
                      <td>64</td>
                      <td>64</td>
                      <td>645</td>
                      <td>64</td>
                      <td>-</td>
                      <td>645</td>
                      <td>645</td>
                      <td className="td_point">
                        승인
                        <br /> 2025, 08, 30
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>

          <section className="box">
            <div className="com_board_box">
              <div className="tab_wrap">
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              </div>
              <table className="com_board_list">
                <colgroup>
                  <col width="25%" />
                  <col width="25%" />
                  <col width="25%" />
                  <col width="25%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>총 포인트</th>
                    <td className="com_blue_txt">63456,000</td>
                    <th>현 보유 포인트</th>
                    <td className="com_blue_txt">63456,000</td>
                  </tr>
                </tbody>
              </table>

              <table className="com_board_list">
                <colgroup>
                  <col width="30" />
                  <col width="100" />
                  <col width="90" />
                  <col width="auto" />
                  <col width="60" />
                  <col width="90" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>변경일</th>
                    <th>요청자</th>
                    <th>요청내용</th>
                    <th>등록</th>
                    <th>보유 포인트</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>2022, 08, 25</td>
                    <td>홍길동101</td>
                    <td>제안채택</td>
                    <td className="com_red_txt">-10</td>
                    <td className="com_blue_txt">65421</td>
                  </tr>
                  {[2, 3, 4, 5].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{idx + 2}</td>
                        <td>2022, 08, 25</td>
                        <td>홍길동101</td>
                        <td>제안채택</td>
                        <td className="com_blue_txt">+10</td>
                        <td className="com_blue_txt">65421</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김관리 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <div className="tit">요청 사유</div>
                  <div className="cont">교관활동 ㅣ 정기교육</div>
                </div>
                <div className="info">
                  <div className="tit">요청 포인트</div>
                  <div className="cont"> + 23</div>
                </div>
                <div className="info">
                  <div className="tit">메모</div>
                  <div className="cont">2023년 3기 교관활동을 16회 하였습니다.</div>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon blue">포인트 변경</span>
                    <button className="name">김관리 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <div className="tit">요청 사유</div>
                  <div className="cont">교관활동 ㅣ 정기교육</div>
                </div>
                <div className="info">
                  <div className="tit">요청 포인트</div>
                  <div className="cont"> + 23</div>
                </div>
                <div className="info">
                  <div className="tit">메모</div>
                  <div className="cont">2023년 3기 교관활동을 16회 하였습니다.</div>
                </div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_row">
                <select className="select">
                  <option value="승인 불가">승인 불가</option>
                </select>
                <div className="desc_notice">
                  ㆍ요청 사유 : 교관활동 ㅣ 정기교육 <br />
                  ㆍ요청포인트 : <span className="com_blue_txt">+ 23</span>
                </div>
              </div>
              <textarea className="textarea" placeholder="내용 입력"></textarea>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">승인</button>
            </div>
          </section>
        </section>
      </div>
      <PopRequestPoint open={modalOpen} close={() => setModalOpen(false)} />
      <PopPolicyPosition open={modalPositionOpen} close={() => setModalPositionOpen(false)} />
      <PopPolicyPoint open={modalPolicyOpen} close={() => setModalPolicyOpen(false)} />
    </main>
  );
}

export default IncentiveDetail;
